import {definePreset} from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#f4f5f7',
      100: '#e6e8ec',
      200: '#c9cdd6',
      300: '#a8aebb',
      400: '#87909e',
      500: '#6a7282',
      600: '#535a67',
      700: '#3e444f',
      800: '#2c3240',
      900: '#1e2329',
      950: '#141820'
    },
    colorScheme: {
      light: {
        primary: {
          color:         '#b45309',
          contrastColor: '#ffffff',
          hoverColor:    '#92400e',
          activeColor:   '#6f2e0a'
        },
        highlight: {
          background:      'rgba(180, 83, 9, 0.10)',
          focusBackground: 'rgba(180, 83, 9, 0.20)',
          color:           '#b45309',
          focusColor:      '#92400e'
        }
      },
    }
  },
  components: {
    inputtext: {
      root: {
        paddingX: '0.625rem',
        paddingY: '0.375rem',
        background: '{primary.50}',
      }
    },
    select: {
      root: {
        paddingX: '0.625rem',
        paddingY: '0.375rem',
        background: '{primary.50}',
      }
    },
    multiselect: {
      root: {
        paddingX: '0.625rem',
        paddingY: '0.375rem',
        background: '{primary.50}',
      }
    },
    textarea: {
      root: {
        paddingX: '0.625rem',
        paddingY: '0.375rem',
        background: '{primary.50}',
      }
    },
    button: {
      root: {
        paddingX: '0.625rem',
        paddingY: '0.375rem',
      }
    }
  }
});

export default MyPreset;
